import { jsx as _jsx } from "react/jsx-runtime";
import { FileTypeFile, FileTypeImage, FileTypePdf, FileTypeVideo, } from '@otp/icons';
export const FileType = ({ type }) => {
    switch (type) {
        case 'pdf':
            return _jsx(FileTypePdf, {});
        case 'image':
            return _jsx(FileTypeImage, {});
        case 'video':
            return _jsx(FileTypeVideo, {});
        default:
            return _jsx(FileTypeFile, {});
    }
};
